import { ChartFragment } from 'models/api-response';
import { ChartTable } from 'models/ui';
import { Sidebar } from 'components/common';
import DataReviewSidebar from './DataReviewSidebar';

export interface SavedVitalSignsProps {
  isSidebarOpen: boolean;
  selectedRecord: ChartFragment;
  navId: string;
  onClose: () => void;
  loadData: () => Promise<void>;
  dataSource?: ChartTable['data'];
  ageInDays: number;
}

export const SavedVitalSignsReview = ({ isSidebarOpen, selectedRecord, onClose, navId, loadData, dataSource, ageInDays }: SavedVitalSignsProps) => {
  return (
    <Sidebar open={isSidebarOpen} onClose={onClose}>
      <DataReviewSidebar ageInDays={ageInDays} fragment={selectedRecord} navId={navId} loadData={loadData} dataSource={dataSource} />
    </Sidebar>
  );
};
